/**
 * Resolve or reject the promise after a minimum delay
 */
const DelayedPromise = ( promise, delay ) => new Promise(
    ( resolve => setTimeout( () => resolve( promise ), delay ) ),
)

export default DelayedPromise
